import { spacing, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { base } from "./base.js";
import { startSecond } from "./child.js";
const classNamePrefix = "umd-layout-grid-gap";
const fourColumnCenteredChild = {
  "& > *:first-child": {
    ...startSecond
  }
};
const paragraphOverwrite = {
  "& > p:not(:last-child)": {
    marginBottom: 0
  }
};
function composeGap(options) {
  const { columns, size = "normal", centered = false } = options;
  let composed = {};
  let className = `${classNamePrefix}`;
  let deprecatedAliases = [];
  if (columns === "stacked") {
    return objectWithClassName({
      display: "grid",
      gridTemplateColumns: "1fr",
      gridGap: `${spacing.md}`,
      [`@media (${media.queries.desktop.min})`]: {
        gridGap: `${spacing.xl}`
      },
      className: [
        `${classNamePrefix}-stacked`,
        /** @deprecated Use 'umd-layout-grid-gap-stacked' instead */
        "umd-grid-gap-stacked"
      ]
    });
  }
  let baseGrid;
  if (columns === 2) {
    baseGrid = base.two;
  } else if (columns === 3) {
    baseGrid = base.three;
  } else {
    baseGrid = base.four;
  }
  composed = { ...baseGrid };
  if (columns === 2) {
    composed = {
      ...composed,
      [`@media (${media.queries.large.min})`]: {
        gridTemplateColumns: "repeat(2, 1fr)",
        gridGap: spacing.lg,
        ...paragraphOverwrite
      }
    };
    if (size === "normal") {
      composed = {
        ...composed,
        [`@media (${media.queries.desktop.min})`]: {
          gridGap: spacing.xl
        }
      };
    }
    className = `${classNamePrefix}-two`;
    deprecatedAliases.push("umd-grid-gap");
  } else if (columns === 3) {
    composed = {
      ...composed,
      [`@media (${media.queries.large.min})`]: {
        gridGap: spacing.lg,
        ...paragraphOverwrite
      }
    };
    if (size === "large") {
      composed = {
        ...composed,
        [`@media (${media.queries.desktop.min})`]: {
          gridTemplateColumns: "repeat(3, 1fr)",
          gridGap: spacing.xl,
          ...paragraphOverwrite
        }
      };
      className = `${classNamePrefix}-three-large`;
      deprecatedAliases.push("umd-grid-gap-three-large");
    } else {
      className = `${classNamePrefix}-three`;
      deprecatedAliases.push("umd-grid-gap-three");
    }
  } else if (columns === 4) {
    composed = {
      ...composed,
      [`@media (${media.queries.large.min})`]: {
        gridGap: spacing.lg,
        gridTemplateColumns: "repeat(2, 1fr)",
        ...paragraphOverwrite
      }
    };
    if (size === "large") {
      composed = {
        ...composed,
        [`@media (${media.queries.highDef.min})`]: {
          gridGap: spacing.xl,
          ...paragraphOverwrite
        }
      };
      if (centered) {
        composed = {
          ...composed,
          ...fourColumnCenteredChild
        };
        className = `${classNamePrefix}-four-large-centered`;
        deprecatedAliases.push("umd-grid-gap-four-center");
      } else {
        className = `${classNamePrefix}-four-large`;
        deprecatedAliases.push("umd-grid-gap-four-large");
      }
    } else {
      if (centered) {
        composed = {
          ...composed,
          ...fourColumnCenteredChild
        };
        className = `${classNamePrefix}-four-centered`;
        deprecatedAliases.push("umd-grid-gap-four-center");
      } else {
        className = `${classNamePrefix}-four`;
        deprecatedAliases.push("umd-grid-gap-four");
      }
    }
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const two = composeGap({ columns: 2 });
const three = composeGap({ columns: 3 });
const threeLarge = composeGap({ columns: 3, size: "large" });
const four = composeGap({ columns: 4 });
const fourCentered = composeGap({ columns: 4, centered: true });
const fourLarge = composeGap({ columns: 4, size: "large" });
const fourLargeCentered = composeGap({
  columns: 4,
  size: "large",
  centered: true
});
const stacked = composeGap({ columns: "stacked" });
export {
  composeGap,
  four,
  fourCentered,
  fourLarge,
  fourLargeCentered,
  stacked,
  three,
  threeLarge,
  two
};
//# sourceMappingURL=gap.js.map
